class ProductCushionUpsell extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['option-choice']
  }

  connectedCallback () {
    super.connectedCallback()

    this.updatePrice()
    this.updateCartInputs()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOptionChange = this.handleOptionChange.bind(this)
    this.handleQuantityChange = this.handleQuantityChange.bind(this)
    this.updatePrice = this.updatePrice.bind(this)
    this.updateCartInputs = this.updateCartInputs.bind(this)

    this.els['option-choice']?.elements.forEach((optionEl) => {
      this.listeners.add(optionEl, 'change', this.handleOptionChange)
    })

    this.listeners.add(
      document,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.handleQuantityChange,
    )

    // The price re-rendered on change
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.updatePrice,
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.updatePrice,
    )
  }

  handleOptionChange () {
    this.updatePrice()
    this.updateCartInputs()
  }

  handleQuantityChange () {
    this.syncUpsellQuantity()
  }

  /**
   * The upsell product as hidden line item
   */
  updateCartInputs () {
    const upsellSelected = this.upsellSelected;

    ['upsell-input', 'upsell-quantity'].forEach((name) => {
      this.getProductElements(name).forEach((el) => {
        el.disabled = !upsellSelected
      })
    })

    this.syncUpsellQuantity()
  }

  syncUpsellQuantity () {
    this.getProductElements('upsell-quantity').forEach((el) => {
      const coverQuantityEl = el.form?.querySelector(
        'input[name="items[0][quantity]"]',
      )

      el.value = coverQuantityEl?.value || '1'
    })
  }

  updatePrice () {
    const datasetKey = this.upsellSelected ? 'upsellPrice' : 'defaultPrice';

    ['price', 'compare-price', 'discount', 'rrp'].forEach((name) => {
      this.getProductElements(name).forEach((el) => {
        const value = el.dataset[datasetKey]

        if (value === undefined) return

        el.innerHTML = value
      })
    })
  }

  /**
   * Gets external elements by name, keeping only those inside the product-info
   * that matches this component's `data-product-info-id`.
   * @param {string} name
   * @returns {HTMLElement[]}
   */
  getProductElements (name) {
    const elements = this.externalEls[name]?.elements || []
    const productInfoId = this.dataset.productInfoId

    if (!productInfoId) return elements

    return elements.filter(
      (el) =>
        el.closest('[data-product-info-id]')?.dataset.productInfoId ===
        productInfoId,
    )
  }

  /**
   * @returns {boolean} check if upsell product is selected
   */
  get upsellSelected () {
    const checkedEl = this.els['option-choice']?.elements.find(
      (optionEl) => optionEl.checked,
    )

    return checkedEl?.dataset.isUpsell === 'true'
  }
}

if (!customElements.get('product-cushion-upsell')) {
  customElements.define('product-cushion-upsell', ProductCushionUpsell)
}
